export default __webpack_public_path__ + "static/media/Shetty.3573b744.png";